
document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a');
        // Loop through each link
        links.forEach(link => {
        if (link.hostname !== window.location.hostname) {
            link.classList.add('external-link');
        }
        });
});